import { PolicyProductIdEnum } from 'outshared-lib';

export const productNameConfig = {
    [PolicyProductIdEnum.Liability]: 'aansprakelijkheid',
    [PolicyProductIdEnum.Moped]: 'bromfiets',
    [PolicyProductIdEnum.Caravan]: 'caravan',
    [PolicyProductIdEnum.Pet]: 'huisdier',
    [PolicyProductIdEnum.Bicycle]: 'fiets',
    [PolicyProductIdEnum.Accidents]: 'ongevallen',
    [PolicyProductIdEnum.Motorcycle]: 'motor',
    [PolicyProductIdEnum.LegalAssistance]: 'rechtsbijstand',
    [PolicyProductIdEnum.Home]: 'woonhuis',
    [PolicyProductIdEnum.Car]: 'auto',
    [PolicyProductIdEnum.Travel]: 'reis',
};
